import { Controller } from '@hotwired/stimulus';

// 従業員名で絞り込む(旧 paybook.js の #employee_name / #sendModalAllContentEmployee)。
// filterColumns: #payments の col/th/td.user_<id> を絞る(給与一覧)。
// filterRows: .send-payslip-table の tr.modal_user_<id> を絞る(一括送信モーダル)。
export default class extends Controller {
  filterColumns(event) {
    const payments = document.getElementById('payments');
    if (!payments) return;
    const value = event.target.value;

    const setAll = (display) => {
      payments.querySelectorAll('col.user, th.user, td.user').forEach((el) => {
        el.style.display = display;
      });
    };

    if (value === '') {
      setAll('');
      return;
    }

    const searching = this.toRegExp(value);
    const userIds = [];
    payments.querySelectorAll('a.staffname').forEach((el) => {
      const key = el.dataset.searchKey || '';
      if (searching.test(key)) userIds.push(el.dataset.userId);
    });
    if (userIds.length === 0) return;

    setAll('none');
    userIds.forEach((id) => {
      payments
        .querySelectorAll(`col.user_${id}, th.user_${id}, td.user_${id}`)
        .forEach((el) => (el.style.display = ''));
    });
  }

  filterRows(event) {
    const table = document.querySelector('.send-payslip-table');
    if (!table) return;
    const value = event.target.value;
    const rows = table.querySelectorAll('tr.modal_user');

    if (value === '') {
      table.querySelectorAll('tr').forEach((tr) => (tr.style.display = ''));
      return;
    }

    const searching = this.toRegExp(value);
    const userIds = [];
    rows.forEach((el) => {
      const key = el.dataset.searchKey || '';
      if (searching.test(key)) userIds.push(el.dataset.userId);
    });
    if (userIds.length === 0) return;

    rows.forEach((tr) => (tr.style.display = 'none'));
    userIds.forEach((id) => {
      table
        .querySelectorAll(`tr.modal_user_${id}`)
        .forEach((tr) => (tr.style.display = ''));
    });
  }

  toRegExp(value) {
    try {
      return new RegExp(value);
    } catch {
      // 不正な正規表現(未エスケープのメタ文字)はリテラル一致にフォールバック。
      return new RegExp(value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    }
  }
}
